
import Import3 from "../../../assets/filled/Import3.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Import3Icon({ className, dataTestid = "Import3Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Import3 data-testid={dataTestid} className={classes} {...rest} />
  );
}
